import { UINT } from '../fields/UINT.js';
/**
 * Parse a ProtectionSystemSpecificHeaderBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed ProtectionSystemSpecificHeaderBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function pssh(view) {
    const { readUint, readArray } = view;
    const { version, flags } = view.readFullBox();
    const systemId = readArray(UINT, 1, 16);
    let kidCount = 0;
    let kid = [];
    if (version > 0) {
        kidCount = readUint(4);
        kid = readArray(UINT, 1, kidCount);
    }
    const dataSize = readUint(4);
    const data = readArray(UINT, 1, dataSize);
    return {
        version,
        flags,
        systemId,
        kidCount,
        kid,
        dataSize,
        data,
    };
}
;
//# sourceMappingURL=pssh.js.map